/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const overrideTimeOptionsResponseOutputTimeZoneMax = 100;

export const overrideTimeOptionsResponseOutputLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const overrideTimeOptionsResponseOutputLocalTimeRegExp = new RegExp(
  '^(?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const overrideTimeOptionsResponseOutputCandidatesItemInstantRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const overrideTimeOptionsResponseOutputCandidatesItemOffsetRegExp = new RegExp(
  '^[+-](?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const overrideTimeOptionsResponseOutputCandidatesMax = 2;

export const OverrideTimeOptionsResponseOutput = zod.object({
  timeZone: zod.string().min(1).max(overrideTimeOptionsResponseOutputTimeZoneMax),
  localDate: zod.iso.date().regex(overrideTimeOptionsResponseOutputLocalDateRegExp),
  localTime: zod.string().regex(overrideTimeOptionsResponseOutputLocalTimeRegExp),
  candidates: zod
    .array(
      zod.object({
        instant: zod.iso
          .datetime({ offset: true })
          .regex(overrideTimeOptionsResponseOutputCandidatesItemInstantRegExp),
        offset: zod.string().regex(overrideTimeOptionsResponseOutputCandidatesItemOffsetRegExp),
        occurrence: zod.enum(['first', 'second']),
      }),
    )
    .max(overrideTimeOptionsResponseOutputCandidatesMax),
});

export type OverrideTimeOptionsResponseOutput = zod.input<typeof OverrideTimeOptionsResponseOutput>;
export type OverrideTimeOptionsResponseOutputOutput = zod.output<
  typeof OverrideTimeOptionsResponseOutput
>;
